import { useMemo } from 'react'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { Typography } from 'common/widgets'
import classNames from './styles.module.scss'


Branches.propTypes = {
  branches: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    phone_number: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    address_city: PropTypes.string,
    address_postal_code: PropTypes.string,
    opening_times: PropTypes.string,
  })),
}

export default function Branches({
  branches = [],
}) {
  const branchItems = useMemo(() => (branches || []).map(({ uuid, name, address_line_1: firstAddress, address_line_2: secondAddress, address_city: city, address_postal_code: postalCode, phone_number: phoneNumber, email, opening_times: openingTimes }) => {
    // Address line 1 + line 2, comma only when both are present
    const addressLine = [firstAddress, secondAddress].filter(Boolean).join(', ')
    // Postal code + city, space-separated (no comma)
    const cityLine = [postalCode, city].filter(Boolean).join(' ')

    return (
      <Col key={uuid || firstAddress} span={24} sm={12} lg={6} className={classNames.column}>
        <Typography variant="h4" className={classNames.city}>{name}</Typography>
        {openingTimes && (
          <Typography variant="content" color="light-black" className={classNames.text}>
            {openingTimes}
          </Typography>
        )}
        {addressLine && (
          <Typography variant="content" color="light-black" className={classNames.text}>
            {addressLine}
          </Typography>
        )}
        {cityLine && (
          <Typography variant="content" color="light-black" className={classNames.text}>
            {cityLine}
          </Typography>
        )}
        {phoneNumber && (
          <Typography
            tag="a"
            href={`tel:${phoneNumber}`}
            variant="content"
            color="light-black"
            className={classNames.text}
          >
            {phoneNumber}
          </Typography>
        )}
        {email && (
          <Typography
            tag="a"
            href={`mailto:${email}`}
            variant="content"
            color="light-black"
            className={classNames.text}
          >
            {email}
          </Typography>
        )}
      </Col>
    )
  }), [branches])

  return <Row gutter={[32, 32]}>{branchItems}</Row>
}
